import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { getDisplayName } from '@grandvisionhq/utils';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../utils/http-client.js';
import '@grandvisionhq/state';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../operations/mutations/signup-promotion.js';
import '../operations/mutations/subscribe-newsletter.js';
import '../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBreakpointVisibility } from '../hooks/use-breakpoint-visibility.js';

function withBreakpointVisibility(Component) {
    const displayName = getDisplayName(Component);
    const WithBreakpointVisibility = (props)=>{
        return useBreakpointVisibility(props) ? /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props)) : null;
    };
    WithBreakpointVisibility.displayName = `WithBreakpointVisibility(${displayName})`;
    return WithBreakpointVisibility;
}

export { withBreakpointVisibility };
//# sourceMappingURL=with-breakpoint-visibility.js.map
